"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "login": {
    "onlineTraining": "ເວທີການຝຶກອົບຮົມ Online Liaogao e Academy",
    "captchaNotEmpty": "ລະຫັດຢືນຢັນຕ້ອງຖືກຕື່ມ",
    "accountNotEmpty": "ບັນຊີບໍ່ສາມາດປ່ອຍໃຫ້ຫວ່າງໄດ້",
    "passwordBits": "ຄວາມຍາວຂອງລະຫັດຜ່ານບໍ່ສາມາດຕ່ ຳ ກວ່າ 6 ຕົວເລກ",
    "incorrectTips": "ຊື່ຜູ້ໃຊ້ຫລືລະຫັດຜ່ານເຂົ້າລະຫັດບໍ່ຖືກຕ້ອງ",
    "sign": "ເຂົ້າ​ສູ່​ລະ​ບົບ",
    "passwordNotEmpty": "ລະຫັດຜ່ານບໍ່ສາມາດເປົ່າ",
    "passwordBitsLong": "ຄວາມຍາວຂອງລະຫັດຜ່ານບໍ່ສາມາດໃຫຍ່ກວ່າ 18 ຕົວເລກ",
    "captchaTips": "ລະຫັດຢັ້ງຢືນບໍ່ຖືກຕ້ອງ",
    "confirmNot": "ລະຫັດຜ່ານທີ່ປ້ອນເຂົ້າແມ່ນບໍ່ສອດຄ່ອງກັບລະຫັດຜ່ານທີ່ຖືກຢືນຢັນ",
    "inputAccount": "ກະລຸນາໃສ່ຊື່ຜູ້ໃຊ້",
    "inputPassword": "ກະລຸນາໃສ່ລະຫັດຜ່ານ",
    "inputCaptcha": "ກະລຸນາໃສ່ລະຫັດຢືນຢັນ",
    "forgetPassword": "ລືມລະຫັດຜ່ານ",
    "nextStep": "ຂັ້ນ​ຕອນ​ຕໍ່​ໄປ",
    "inputUserName": "ກະລຸນາໃສ່ຊື່ຜູ້ໃຊ້",
    "phoneNumber": "ເບີ​ໂທລະ​ສັບ",
    "phoneEmpty": "ເບີໂທລະສັບບໍ່ສາມາດຫວ່າງໄດ້",
    "surePasswordEmpty": "ຢືນຢັນລະຫັດຜ່ານບໍ່ສາມາດປ່ອຍໃຫ້ຫວ່າງໄດ້",
    "userNameEmpty": "ຊື່ຜູ້ໃຊ້ບໍ່ສາມາດຫວ່າງໄດ້",
    "getCaptcha": "ໄດ້ຮັບລະຫັດຢືນຢັນ",
    "msgCaptcha": "ລະຫັດຢືນຢັນ SMS",
    "prevStep": "ທີ່ຜ່ານມາ",
    "surePassword": "ກະລຸນາຢືນຢັນລະຫັດຜ່ານຂອງທ່ານ",
    "reset": "ປັບ ໃໝ່",
    "resetSuccess": "ຕັ້ງຄ່າ ສຳ ເລັດແລ້ວ",
    "resetSuccessTips": "ທ່ານໄດ້ຕັ້ງລະຫັດຜ່ານ ໃໝ່ ສຳ ເລັດແລ້ວ, ກະລຸນາເຂົ້າສູ່ລະບົບ",
    "loginNow": "ເຂົ້າສູ່ລະບົບດຽວນີ້",
    "copyRight": "ລິຂະສິດແມ່ນເປັນຂອງ by, ລິຂະສິດ @ 2020 京 ICP 备案",
    "loginFail": "ການເຂົ້າສູ່ລະບົບລົ້ມເຫລວ, ກະລຸນາລອງ ໃໝ່ ອີກຄັ້ງ!",
    "captchaFail": "ການຢືນຢັນລະຫັດຢືນຢັນລົ້ມເຫລວ",
    "failTips": "ການຢັ້ງຢືນລົ້ມເຫລວ",
    "inputOrigPassword": "ກະລຸນາໃສ່ລະຫັດລັບເດີມ",
    "inputNewPassowrd": "ກະລຸນາໃສ່ລະຫັດລັບ ໃໝ່",
    "confimPassword": "ກະລຸນາຢືນຢັນລະຫັດຜ່ານຂອງທ່ານ",
    "sure": "ກຳ ນົດ",
    "cancel": "ຍົກເລີກ",
    "changePasswordSuccess": "ລະຫັດຜ່ານໄດ້ຖືກປັບປຸງ",
    "continueLogin": "ລົງທະບຽນ ໃໝ່",
    "resetLoginTips": "ທ່ານໄດ້ປ່ຽນລະຫັດຜ່ານຂອງທ່ານຢ່າງ ສຳ ເລັດຜົນ, ທ່ານ ຈຳ ເປັນຕ້ອງເຂົ້າສູ່ລະບົບອີກຄັ້ງ, ແລະອອກຈາກລະບົບໂດຍອັດຕະໂນມັດພາຍຫຼັງ 3 ວິນາທີ",
    "passwordFormat": "ຄວາມຍາວລະຫັດຜ່ານແມ່ນ 8 ຫາ 32 ຕົວເລກ, ລວມທັງຕົວເລກແລະຕົວອັກສອນໃຫຍ່ແລະຕົວອັກສອນນ້ອຍ",
    "changePassword": "ປ່ຽນ​ລະ​ຫັດ​ຜ່ານ",
    "poor": "ອ່ອນແອ",
    "middle": "ໃນ",
    "strong": "ແຂງແຮງ",
    "logout": "ອອກຈາກລະບົບ ສຳ ເລັດແລ້ວ",
    "formerPhone": "ເບີໂທລະສັບເດີມ",
    "newPhone": "ເບີໂທລະສັບ ໃໝ່",
    "changePhoneSuccess": "ເບີໂທລະສັບມືຖືທີ່ຖືກປັບປ່ຽນປະສົບຜົນ ສຳ ເລັດ",
    "changePhoneSuccessTips": "ທ່ານໄດ້ແກ້ໄຂເບີໂທລະສັບຂອງທ່ານແລ້ວ",
    "goHome": "ໄປທີ່ ໜ້າ ຫຼັກ",
    "changePhone": "ແກ້ໄຂເບີໂທລະສັບມືຖື",
    "newPhoneEmpty": "ເບີໂທລະສັບ ໃໝ່ ບໍ່ສາມາດຫວ່າງໄດ້",
    "newPhoneFomat": "ຮູບແບບເບີໂທລະສັບ ໃໝ່ ບໍ່ຖືກຕ້ອງ",
    "newPhoneSupport": "ເບີໂທລະສັບ ໃໝ່ ນີ້ບໍ່ສາມາດຄືກັບເບີໂທລະສັບເດີມ",
    "newPhoneBinded": "ເບີໂທລະສັບ ໃໝ່ ຖືກຜູກມັດແລ້ວ",
    "orgPhoneEmpty": "ເບີໂທລະສັບເດີມບໍ່ສາມາດຫວ່າງໄດ້",
    "orgPhoneFormat": "ຮູບແບບເບີໂທລະສັບເດີມແມ່ນບໍ່ຖືກຕ້ອງ",
    "orgPhoneNot": "ເບີໂທລະສັບເດີມບໍ່ຖືກຕ້ອງ",
    "resetPassword": "ຕັ້ງລະຫັດຜ່ານ ໃໝ່",
    "phoneCaptchaEmpty": "ລະຫັດຢືນຢັນໂທລະສັບບໍ່ສາມາດປ່ອຍໃຫ້ຫວ່າງໄດ້",
    "accountVerif": "ການຢັ້ງຢືນບັນຊີ",
    "phoneVerif": "ການຢັ້ງຢືນໂທລະສັບ",
    "resetDone": "ການຕັ້ງຄ່າ ສຳ ເລັດແລ້ວ",
    "phoneFormat": "ຮູບແບບເບີໂທລະສັບບໍ່ຖືກຕ້ອງ",
    "phoneBinded": "ເບີໂທລະສັບມືຖືຖືກຜູກມັດແລ້ວ",
    "loginVertif": "ເຂົ້າສູ່ລະບົບກວດສອບຄວາມຖືກຕ້ອງ",
    "clickGoHome": "ກົດເພື່ອກັບໄປ ໜ້າ ເຂົ້າສູ່ລະບົບ",
    "bingPhoneSuccess": "ຜູກເບີໂທລະສັບມືຖືໃຫ້ປະສົບຜົນ ສຳ ເລັດ",
    "rightMessageChange": "ທ່ານສາມາດແກ້ໄຂມັນຢູ່ໃນຂໍ້ມູນສ່ວນຕົວຢູ່ເບື້ອງຂວາຂອງແຖບນໍາທາງ",
    "bingPhone": "ຜູກເບີໂທລະສັບມືຖື"
  },
  "index": {
    "setAsHomePage": "ຕັ້ງຄ່າເປັນ ໜ້າ ຕໍ່ ໜ້າ",
    "addCollection": "ເພີ່ມເຂົ້າໃນໃຈ",
    "telephone": "ສະ ໜັບ ສະ ໜູນ ສາຍດ່ວນ",
    "Help": "ສູນຊ່ວຍເຫຼືອ",
    "SystemMessage": "ເຕືອນລະບົບ",
    "message": "ຂ່າວ",
    "emptyMessage": "ຫວ່າງເປົ່າ",
    "checkAllMessage": "ເບິ່ງ​ທັງ​ຫມົດ",
    "noMessage": "ບໍ່​ມີ​ຂໍ້​ມູນ",
    "fullScreen": "ຈໍສະແດງຜົນເຕັມຈໍ",
    "ExitSystem": "ອອກຈາກລະບົບນີ້",
    "back": "ກັບຄືນ",
    "top": "ດ້ານເທິງ",
    "backToTop": "ກັບໄປທາງເທີງ",
    "homePage": "ເຮືອນ",
    "course": "ການຮຽນຫລັກສູດ",
    "onlineCourse": "ຫ້ອງພິເສດ Online",
    "faceCourse": "ການຝຶກອົບຮົມແບບ ໜ້າ",
    "examPractice": "ການປະຕິບັດການສອບເສັງ",
    "dataDownLoad": "ດາວໂຫລດ",
    "userInfo": "ສູນກາງສ່ວນບຸກຄົນ",
    "Administration": "ພື້ນຖານການຄຸ້ມຄອງ",
    "courseCategory": "ຄັດປະເພດຫຼັກສູດ",
    "examIsOver": "ການປະເມີນຜົນ ສຳ ເລັດ",
    "onlineHours": "ຊົ່ວໂມງ online",
    "faceHours": "ຊົ່ວໂມງຮຽນຕໍ່ ໜ້າ",
    "notice": "ການປະກາດ",
    "checkAllNotice": "ເບິ່ງ​ທັງ​ຫມົດ",
    "backToTopButton": "ກັບໄປທາງເທີງ",
    "recommendCourse": "ຫລັກສູດທີ່ແນະ ນຳ",
    "impotentCourse": "ຫຼັກສູດຫຼັກ",
    "newCourse": "ຫລັກສູດ ໃໝ່ ລ້າສຸດ",
    "hotCourse": "ຫລັກສູດທີ່ຮ້ອນທີ່ສຸດ",
    "requiredCourses": "ຫຼັກສູດການບັງຄັບ",
    "electiveCourses": "ຫຼັກສູດການເລືອກ",
    "startStudy": "ເລີ່ມຕົ້ນທີ່ຈະຮຽນຮູ້",
    "continueStudy": "ສືບຕໍ່ຮຽນ",
    "coursesRanking": "ການຈັດອັນດັບການຄັດເລືອກຫຼັກສູດ",
    "studentRanking": "ການຈັດອັນດັບຂອງນັກຮຽນ",
    "currentUser": "ຜູ້ໃຊ້ປະຈຸບັນ",
    "userHead": "ຮູບໂປໄຟ",
    "currentHead": "avatar ປະຈຸບັນ",
    "change": "ປັບປຸງແກ້ໄຂ",
    "accountPassword": "ລະຫັດຜ່ານບັນຊີ",
    "encryPhone": "ໂທລະສັບລັບ",
    "currentPhone": "ໂທລະສັບປະຈຸບັນ",
    "userName": "ຊື່ຜູ້ໃຊ້",
    "head": "avatar",
    "coverImage": "ກວມເອົາຮູບພາບ",
    "uploadError": "ການອັບໂຫລດລົ້ມເຫລວ",
    "autoSetHomeTips": "ໂປຣແກຣມທ່ອງເວັບຂອງທ່ານບໍ່ຮອງຮັບການຕັ້ງຄ່າ ໜ້າ ທຳ ອິດໂດຍອັດຕະໂນມັດ, ກະລຸນາໃຊ້ເມນູ browser ເພື່ອ ກຳ ນົດມັນດ້ວຍຕົນເອງ!",
    "operateConfig": "ການປະຕິບັດງານນີ້ຖືກປະຕິເສດໂດຍຕົວທ່ອງເວັບ. ຖ້າທ່ານຕ້ອງການເປີດໃຊ້ງານນີ້, ກະລຸນາປ້ອນຂໍ້ມູນກ່ຽວກັບ: config ໃນແຖບທີ່ຢູ່, ແລະຫຼັງຈາກນັ້ນ ກຳ ນົດຄ່າຂອງເຊັນຊື່ .applets.codebase_principal_support ໃຫ້ເປັນຄວາມຈິງ",
    "favoriteTips": "ເນື່ອງຈາກຂໍ້ ຈຳ ກັດຂອງ ໜ້າ ທີ່ຂອງ browser 360, ກະລຸນາກົດປຸ່ມ Ctrl + D ເພື່ອ ໝາຍ ໃສ່ປື້ມດ້ວຍຕົນເອງ!",
    "autoFavorite": "ໂປແກຼມທ່ອງເວັບຂອງທ່ານບໍ່ຮອງຮັບມັນ, ກະລຸນາກົດປຸ່ມ Ctrl + D ເພື່ອ ໝາຍ ໃສ່ປື້ມດ້ວຍຕົນເອງ!",
    "required": "ລາຍການນີ້ແມ່ນ ຈຳ ເປັນ",
    "to": "ເຖິງ",
    "trainingTime": "ໄລຍະເວລາການຝຶກອົບຮົມ",
    "coursehours": "ຊົ່ວໂມງຮຽນ",
    "human": "ຄົນ",
    "wecome": "ຍິນດີຕ້ອນຮັບ!",
    "allCourses": "ທຸກວິຊາ"
  },
  "course": {
    "coursesCategory": "ຄັດປະເພດຫຼັກສູດ",
    "allCourses": "ທຸກວິຊາ",
    "electiveCourses": "ຫຼັກສູດການເລືອກຕັ້ງ",
    "requiredCourses": "ຫລັກສູດທີ່ຕ້ອງການ",
    "collect": "ສິ່ງທີ່ມັກ",
    "cancelCollect": "ບໍ່ມັກ",
    "searchTips": "ກະລຸນາໃສ່ຊື່ຫຼັກສູດ",
    "startStudy": "ເລີ່ມຕົ້ນທີ່ຈະຮຽນຮູ້",
    "continueStudy": "ສືບຕໍ່ຮຽນ",
    "cancelConfirm": "ບໍ່ມັກ",
    "cancelTips": "ຢືນຢັນການຍົກເລີກການກະຕຸ້ນເຕືອນ",
    "confirmButton": "ປຸ່ມຍົກເລີກ",
    "count": "ລວມ",
    "item": "ມາດຕາ",
    "up": "ໜ້າ ກ່ອນ ໜ້າ ນີ້",
    "next": "ໜ້າ ຕໍ່ໄປ",
    "items": "ມາດຕາ / ໜ້າ",
    "go": "ໄປຫາ",
    "page": "ຫນ້າ",
    "man": "ຄົນ",
    "score": "ນາທີ",
    "courseYear": "ປີ",
    "courseTeachers": "ຄູອາຈານ",
    "noDesc": "ບໍ່ມີການແນະ ນຳ",
    "teachersDesc": "ຂໍ້ມູນຂອງຄູ",
    "checkLog": "ເບິ່ງບັນທຶກ",
    "reExam": "ທົດລອງ ໃໝ່",
    "examLog": "ບັນທຶກການສອບເສັງ",
    "viewPaper": "ເບິ່ງເຈ້ຍທົດສອບ",
    "noPublicExam": "ເອກະສານທົດສອບຈະບໍ່ຖືກປະກາດ",
    "marking": "ເຄື່ອງ ໝາຍ",
    "closeButton": "ປິດ​ເຄື່ອງ",
    "examResultPage": "ໜ້າ ຜົນການສອບເສັງ",
    "examPage": "ໜ້າ ການສອບເສັງ",
    "startExam": "ເລີ່ມສອບເສັງ",
    "coursehours": "ຊົ່ວໂມງຮຽນ",
    "courseInfo": "ລາຍລະອຽດຂອງລາຍວິຊາ",
    "courseChapter": "ບົດວິຊາ",
    "courseNote": "ປື້ມບັນທຶກຂອງລາຍວິຊາ",
    "courseData": "ຂໍ້ມູນຂອງລາຍວິຊາ",
    "courseExamination": "ການສອບເສັງ",
    "evaluate": "ການປະເມີນຜົນ",
    "courseEvaluate": "ການປະເມີນຫລັກສູດ",
    "no": "ກ່ອນອື່ນ ໝົດ",
    "chapter": "ບົດ",
    "isEvaluate": "ການປະເມີນຜົນ",
    "uploadDate": "ເວລາໂຫລດ",
    "className": "ຊື່ຊັ້ນ",
    "resourceSize": "ຂະ ໜາດ ຂອງຊັບພະຍາກອນ",
    "times": "ເທື່ອ",
    "typeViedo": "ວິດີໂອ",
    "typeImage": "ຮູບພາບ",
    "typeDoc": "ເອກະສານ",
    "typeOuth": "ອື່ນໆ",
    "typeImages": "ຫລາຍຮູບ",
    "newComment": "ເຖິງວັນທີ",
    "hotComment": "ໜ້າ ຮັກທີ່ສຸດ",
    "openComment": "ຂ້ອຍຢາກໃຫ້ ຄຳ ເຫັນ",
    "cancelButton": "ຍົກເລີກ",
    "publishButton": "ປ່ອຍຕົວ",
    "commentTips": "ກະລຸນາໃສ່ເນື້ອໃນ ຄຳ ເຫັນ",
    "emptyCommentTips": "ເນື້ອຫາ ຄຳ ເຫັນບໍ່ສາມາດປ່ອຍໃຫ້ຫວ່າງໄດ້",
    "noteSource": "ຈາກ",
    "deleteNoteButton": "ລົບ",
    "needIETips": "ເຄື່ອງມືສອນໃນປະຈຸບັນຮຽກຮ້ອງໃຫ້ມີໂປຣແກຣມທ່ອງເວັບ IE!",
    "donwNum": "ເວລາດາວໂຫລດ",
    "preview": "ເບິ່ງຕົວຢ່າງ",
    "relatedCourses": "ຫລັກສູດທີ່ກ່ຽວຂ້ອງ",
    "studentsNum": "ຈຳ ນວນຫລັກສູດ",
    "courseHours": "ຊົ່ວໂມງຮຽນ",
    "JoinLearning": "ເຂົ້າຮ່ວມການຮຽນຮູ້"
  },
  "onlineclass": {
    "allTheClass": "ທຸກຊັ້ນຮຽນ",
    "beginClass": "ຫ້ອງຮຽນເລີ່ມຕົ້ນ",
    "notBeginClass": "ບໍ່ມີຊັ້ນ",
    "endClass": "ປິດແລ້ວ",
    "searchThoseClass": "ຄົ້ນຫາຫ້ອງຮຽນພິເສດ online ທີ່ທ່ານສົນໃຈ",
    "startLearn": "ເຂົ້າຫ້ອງຮຽນ",
    "registrationTime": "ເວລາລົງທະບຽນ",
    "to": "ເຖິງ",
    "trainingTime": "ໄລຍະເວລາການຝຶກອົບຮົມ",
    "subjectsClass": "ຫລັກສູດ",
    "classStudy": "ການສຶກສາຊັ້ນ",
    "quantityOfCourses": "ຈຳ ນວນຫລັກສູດ",
    "numberOfParticipants": "ຈຳ ນວນຜູ້ສະ ໝັກ",
    "registerNow": "ລົງ​ທະ​ບຽນ​ດຽວ​ນີ້",
    "resetRegister": "ຖອນຊື່",
    "participating": "ໄດ້ເຂົ້າຮ່ວມ",
    "subjects": "ປະຕູ",
    "classExam": "ການສອບເສັງຊັ້ນ",
    "notParticipat": "ບໍ່ມີສ່ວນຮ່ວມ",
    "startExim": "ເລີ່ມສອບເສັງ",
    "handed": "ປະຕິບັດວຽກມອບ ໝາຍ",
    "score": "ຄະແນນ",
    "cacheSave": "ການເກັບຮັກສາຊົ່ວຄາວ",
    "subjectsNumber": "ຈຳ ນວນປະຕູ",
    "notice": "ແຈ້ງການ",
    "communication": "ການສື່ສານ",
    "detail": "ລາຍລະອຽດ",
    "courses": "ແນ່ນອນ",
    "allClass": "ທັງ ໝົດ",
    "compulsory": "ການບັງຄັບ",
    "elective": "ເລືອກຕັ້ງ",
    "Learned": "ໄດ້ຮຽນຮູ້",
    "classPassIndicator": "ຕົວຊີ້ວັດການຜ່ານຊັ້ນ",
    "excellence": "ດີເລີດ",
    "compulsoryNumber": "ຈຳ ນວນ ໜັງ ສືຜ່ານແດນທີ່ ຈຳ ເປັນ",
    "electiveNumber": "ຈຳ ນວນຜູ້ເລືອກຕັ້ງໄດ້ຜ່ານໄປ",
    "compulsoryStandard": "ຊົ່ວໂມງມາດຕະຖານການບັງຄັບ",
    "electiveStandard": "ຊົ່ວໂມງເລືອກ",
    "examIsPass": "ບໍ່ວ່າຈະເປັນການສອບເສັງຜ່ານໄປ",
    "resource": "ຊັບ​ພະ​ຍາ​ກອນ",
    "source": "ຂໍ້ມູນ",
    "new": "ເຖິງວັນທີ",
    "hot": "ໜ້າ ຮັກທີ່ສຸດ",
    "updateTime": "ເວລາໂຫລດ",
    "downloadCount": "ດາວໂຫລດ",
    "download": "ດາວໂຫລດ",
    "resourceSize": "ຂະ ໜາດ ຂອງຊັບພະຍາກອນ",
    "resourceType": "ປະເພດຂອງ",
    "allType": "ທຸກປະເພດ",
    "videos": "ວິດີໂອ",
    "images": "ຮູບພາບ",
    "document": "ເອກະສານ",
    "others": "ອື່ນໆ",
    "multiImages": "ຫລາຍຮູບ",
    "inforCertificate": "ໃບຢັ້ງຢືນ",
    "notSubmit": "ບໍ່ໄດ້ຮັບຮອງ",
    "submitHomework": "ສົ່ງວຽກບ້ານ",
    "submitTime": "ເວລາຍື່ນສະ ເໜີ",
    "uploadHomework": "ການມອບ ໝາຍ ການອັບໂຫລດ",
    "clickHere": "ກົດ​ບ່ອນ​ນີ້",
    "upload": "ອັບໂຫລດ",
    "formatSupport": "ສະຫນັບສະຫນູນຮູບແບບເອກະສານ",
    "submited": "ສົ່ງ",
    "notApproved": "ບໍ່ໄດ້ຄິດໄລ່",
    "approved": "ການສອບເສັງຜ່ານ",
    "downloadHomework": "ກຳ ຫນົດການດາວໂຫລດ",
    "reSubmit": "ຍື່ນສະ ເໜີ ຄືນ",
    "myScore": "ຄະແນນຂອງຂ້ອຍ",
    "comments": "ຄຳ ເຫັນ",
    "talk": "ສົນທະນາ",
    "category": "ການຈັດປະເພດ",
    "classTalk": "ການສົນທະນາໃນຊັ້ນ",
    "groupTalk": "ການສົນທະນາເປັນກຸ່ມ",
    "wantTalk": "ຂ້ອຍຕ້ອງການປຶກສາຫາລື",
    "publish": "ປ່ອຍຕົວ",
    "undo": "ຍົກເລີກ",
    "delete": "ລົບ",
    "iknow": "ຂ້ອຍ​ເຂົ້າ​ໃຈ​ແລ້ວ",
    "faceCourseClass": "ການຝຶກອົບຮົມແບບ ໜ້າ",
    "onlineClasses": "ຫ້ອງພິເສດ Online",
    "openReservation": "ເປີດຮັບສະ ໝັກ ແລ້ວ",
    "talkTech": "ອາຈານສອນ",
    "address": "ສະຖານທີ່",
    "up": "ສຸດ",
    "noon": "ຕອນທ່ຽງ",
    "down": "ພາຍໃຕ້",
    "even": "ເດິກ",
    "classOvered": "ຫ້ອງຮຽນຈົບແລ້ວ",
    "nopassed": "ຍັງບໍ່ໄດ້ລົງທະບຽນ",
    "inputTalkContent": "ກະລຸນາໃສ່ເນື້ອໃນສົນທະນາ",
    "groupMan": "ຜູ້ ນຳ ກຸ່ມ",
    "showAllGroup": "ເບິ່ງສະມາຊິກທັງ ໝົດ",
    "hideAllGroup": "ເອົາສະມາຊິກໃນທີມ ໝົດ ທຸກຄົນ",
    "showAllMan": "ເບິ່ງນັກຮຽນທຸກຄົນ",
    "hideAllMan": "ເອົານັກຮຽນ ໝົດ",
    "reply": "ຕອບ",
    "isDelete": "ທ່ານແນ່ໃຈບໍ່ທີ່ຈະລຶບ?",
    "cancelLike": "ບໍ່​ມັກ",
    "classNotStar": "ການລົງທະບຽນຮຽນຍັງບໍ່ທັນໄດ້ເລີ່ມຕົ້ນ",
    "classIsEnd": "ການລົງທະບຽນຮຽນໄດ້ສິ້ນສຸດລົງແລ້ວ",
    "clickReset": "ກົດປຸ່ມເພື່ອຖອນຊື່",
    "agentRegister": "ລົງທະບຽນອີກຄັ້ງ",
    "cancelRegister": "ຍົກເລີກການລົງທະບຽນ",
    "reason": "ເຫດ​ຜົນ",
    "inputReason": "ກະລຸນາໃສ່ເຫດຜົນຂອງການຍົກເລີກ",
    "homework": "ການປະຕິບັດງານ",
    "leaveMaxBits": "ເຫດຜົນໃນການຂໍລາພັກບໍ່ໃຫ້ເກີນ 100 ຄຳ",
    "leaveNotEndTime": "ເວລາເລີ່ມຕົ້ນການພັກວຽກບໍ່ສາມາດເທົ່າກັບເວລາສິ້ນສຸດ",
    "sizeNot": "ຂະ ໜາດ ບໍ່ເກີນ",
    "close": "ປິດ​ເຄື່ອງ",
    "teacher": "ຄູອາຈານ",
    "noIntroduction": "ບໍ່ມີການແນະ ນຳ"
  },
  "offlineclass": {
    "fullTimeToFace": "ການສອນແບບ ໜ້າ ຕາເຕັມເວລາ",
    "onlineToFace": "ໃນ ໜ້າ ວຽກ",
    "allClass": "ທຸກຊັ້ນຮຽນ",
    "openClass": "ເປີດຫ້ອງຮຽນ",
    "searchThoseClass": "ຄົ້ນຫາຫລັກສູດການຝຶກອົບຮົມແບບ ໜ້າ ເຊິ່ງທ່ານສົນໃຈ",
    "startLearn": "ກະລຸນາໃສ່ການຮຽນຮູ້",
    "classHours": "ຊົ່ວໂມງຮຽນ",
    "h": "ເວລາ",
    "firstWeek": "ອາທິດທີ 1",
    "askLeave": "ຂ້ອຍຕ້ອງການລາພັກ",
    "monday": "ວັນຈັນ",
    "tuesday": "ວັນອັງຄານ",
    "wednesday": "ວັນພຸດ",
    "thursday": "ວັນພະຫັດ",
    "fridays": "ວັນ​ສຸກ",
    "saturdays": "ໃນ​ວັນ​ເສົາ",
    "sunday": "ໃນ​ວັນ​ອາ​ທິດ",
    "morning": "ຕອນເຊົ້າ",
    "afternoon": "ໃນຕອນບ່າຍ",
    "evening": "ຕອນ​ກາງ​ຄືນ",
    "leaveType": "ປະເພດຂອງການລາພັກ",
    "selectLeaveType": "ກະລຸນາເລືອກປະເພດການລາພັກ",
    "leaveTime": "ຫມົດ​ເວ​ລາ",
    "selctLeaveTime": "ກະລຸນາເລືອກເວລາລາພັກ",
    "reasonLeave": "ເຫດຜົນຂອງການລາພັກ",
    "inputReasonLeave": "ກະລຸນາໃສ່ເຫດຜົນຂອງການລາພັກ",
    "sure": "ກຳ ນົດ",
    "selectTime": "ໄລຍະເວລາການຄັດເລືອກ",
    "casualLeave": "ການພັກຜ່ອນສ່ວນຕົວ",
    "sickLeave": "ລາ​ປ່ວຍ",
    "seven": "ມື້",
    "one": "ຫນຶ່ງ",
    "two": "ສອງ",
    "three": "ສາມ",
    "for": "ສີ່",
    "five": "Fives",
    "six": "ຫົກ",
    "clear": "ຫວ່າງເປົ່າ",
    "evaluating": "ການປະເມີນຜົນ",
    "courseEvaluation": "ການປະເມີນຜົນການສິດສອນ",
    "inputEvaluating": "ກະລຸນາໃສ່ເນື້ອໃນການປະເມີນຜົນ",
    "beDoing": "ກຳ ລັງ ດຳ ເນີນຢູ່",
    "notStarted": "ຍັງບໍ່ທັນໄດ້ເລີ່ມຕົ້ນ",
    "evaluationInProgress": "ການປະເມີນຄວາມຄືບ ໜ້າ",
    "notEvaluation": "ບໍ່ໄດ້ປະເມີນຜົນ",
    "evaluationStartTime": "ການປະເມີນເວລາເລີ່ມຕົ້ນ",
    "startEvaluation": "ເລີ່ມການປະເມີນຜົນ",
    "classEvaluation": "ການປະເມີນຊັ້ນ",
    "photoCategory": "ການຈັດປະເພດອັລບັມ",
    "learningActivity": "ກິດຈະ ກຳ ການຮຽນຮູ້",
    "addPhoto": "ຮູບພາບເພີ່ມ ໃໝ່",
    "photoMessage": "ຂໍ້ມູນຮູບພາບ",
    "photoName": "ຊື່ຮູບພາບ",
    "inputPhotoName": "ກະລຸນາໃສ່ຊື່ຮູບ",
    "uploadPhoto": "ອັບໂຫລດຮູບ",
    "formatSupport": "ສະຫນັບສະຫນູນຮູບແບບ",
    "tickets": "ຈາງ",
    "group": "ກຸ່ມ",
    "notGroup": "ບໍ່ມີການຈັດປະເພດ",
    "groupTalk": "ການສົນທະນາເປັນກຸ່ມ",
    "teacherAbout": "ຂໍ້ມູນຂອງຄູ",
    "teacherTech": "ວິຊາທີ່ຮຽນ",
    "photos": "ອັນລະບັ້ມຮູບພາບ",
    "phontoRequier": "ຮູບພາບຕ້ອງຖືກອັບໂຫລດ",
    "addPhoneTips": "ເພີ່ມແລ້ວປະສົບຜົນ ສຳ ເລັດ, ກະລຸນາລໍຖ້າການທົບທວນຄືນ",
    "sureDelete": "ທ່ານແນ່ໃຈບໍ່ວ່າທ່ານຕ້ອງການລຶບ",
    "deleteSuccess": "ລຶບຖິ້ມແລ້ວ",
    "phoneNameReq": "ຕ້ອງມີຊ່ອງໃສ່ຊື່ຮູບພາບ",
    "longNotBits": "ຄວາມຍາວບໍ່ເກີນ 50 ໂຕອັກສອນ",
    "phoneIsOccur": "ຊື່ຮູບມີຢູ່ແລ້ວ",
    "evaluateTime": "ເວລາປະເມີນຜົນ",
    "evalueteNotStar": "ການປະເມີນຜົນຍັງບໍ່ທັນໄດ້ເລີ່ມຕົ້ນ",
    "evaluateEnds": "ການປະເມີນຜົນໄດ້ສິ້ນສຸດລົງແລ້ວ",
    "isEvaluated": "ສົມມຸດຕິຖານ",
    "at": "ໃນ",
    "submit": "ຍື່ນສະເຫນີ",
    "seeEvalute": "ການປະເມີນຜົນການເບິ່ງ",
    "inputIdea": "ກະລຸນາໃສ່ຄວາມຄິດຂອງທ່ານ",
    "submitFailure": "ລົ້ມເຫລວໃນການຈັດການ",
    "seeRecord": "ເບິ່ງບັນທຶກ",
    "examRecord": "ບັນທຶກການສອບເສັງ",
    "seeSubmite": "ເບິ່ງເຈ້ຍທົດສອບ",
    "resultPage": "ໜ້າ ຜົນການສອບເສັງ",
    "hoursStandard": "ບໍ່ສາມາດສອບເສັງໄດ້ຖ້າຊົ່ວໂມງຮຽນບໍ່ໄດ້ຕາມມາດຕະຖານ",
    "examPage": "ໜ້າ ການສອບເສັງ",
    "questionnaire": "ແບບສອບຖາມ",
    " coursesTaught": "ຫຼັກສູດທີ່ສອນ",
    "passed": "ໂດຍ",
    "is": "ແມ່ນແລ້ວ",
    "not": "ບໍ່",
    "passedState": "ສະຖານະພາບຜ່ານ",
    "sketch": "ຮ່າງ",
    "partySchool": "ຫ້ອງຝຶກອົບຮົມໂຮງຮຽນພັກ",
    "searchPartySchool": "ຄົ້ນຫາຫ້ອງຮຽນການຝຶກອົບຮົມໂຮງຮຽນພັກທີ່ທ່ານສົນໃຈ"
  },
  "exam": {
    "answerWarning": "ຄຳ ຖາມຂອງການສອບເສັງນີ້ແມ່ນ ຄຳ ຖາມດຽວທີ່ບໍ່ສາມາດຕອບແທນໄດ້, ກະລຸນາລະມັດລະວັງກ່ອນ ຄຳ ຖາມຕໍ່ໄປ",
    "inputAnswerTips": "ກະລຸນາຂຽນ ຄຳ ຕອບຂອງທ່ານ",
    "problemPoints": "ການວິເຄາະບັນຫາ",
    "examination": "ລົງທະບຽນເຂົ້າສອບເສັງ",
    "knowledgeCompetition": "ການປະກວດຄວາມຮູ້",
    "practice": "ການປະຕິບັດເອກະລາດ",
    "notRegister": "ບໍ່ໄດ້ລົງທະບຽນ",
    "reviewAudit": "ພາຍໃຕ້ການທົບທວນຄືນ",
    "auditNoPass": "ການກວດສອບລົ້ມເຫລວ",
    "participanted": "ລົງທະບຽນ",
    "participant": "ລົງ​ທະ​ບຽນ",
    "examTime": "ເວລາສອບເສັງ",
    "examHours": "ໄລຍະເວລາ",
    "registration": "ລົງທະບຽນ ສຳ ເລັດແລ້ວ",
    "reRegistration": "ຖອນຊື່",
    "wrongQuestion": "ທະນາຄານ ຄຳ ຖາມທີ່ບໍ່ຖືກຕ້ອງ",
    "noInvolvement": "ບໍ່ມີສ່ວນຮ່ວມ",
    "involvement": "ເຂົ້າຮ່ວມ",
    "searchExamPractice": "ຄົ້ນຫາການສອບເສັງແລະອອກ ກຳ ລັງກາຍທີ່ທ່ານສົນໃຈ",
    "practiced": "ປະຕິບັດ",
    "startPractice": "ເລີ່ມຕົ້ນການປະຕິບັດ",
    "toFavorite": "ເພີ່ມເຂົ້າໃນ Favorites",
    "prevPrevious": "ຄຳ ຖາມທີ່ຜ່ານມາ",
    "nextPrevious": "ຄຳ ຖາມຕໍ່ໄປ",
    "submitAnswers": "ສົ່ງ ຄຳ ຕອບ",
    "rightAnswers": "ຄໍາຕອບທີ່ຖືກຕ້ອງ",
    "yourAnswers": "ຄໍາ​ຕອບ​ຂອງ​ເຈົ້າ",
    "questionsAnalysis": "ການວິເຄາະ ຄຳ ຖາມ",
    "noAnalysis": "ບໍ່ມີຄວາມລະອຽດ",
    "accuracy": "ອັດຕາທີ່ຖືກຕ້ອງ",
    "continuePracticed": "ຮັກສາການປະຕິບັດ",
    "topics": "ຫົວຂໍ້"
  },
  "source": {
    "allResource": "ຊັບພະຍາກອນທັງ ໝົດ",
    "commonResource": "ຊັບພະຍາກອນທົ່ວໄປ",
    "classResource": "ຊັບພະຍາກອນຫ້ອງຮຽນ",
    "resourceCategory": "ການຈັດປະເພດຊັບພະຍາກອນ",
    "searchResource": "ຄົ້ນຫາຊັບພະຍາກອນທີ່ທ່ານສົນໃຈ",
    "resourceTalk": "ການປະເມີນຊັບພະຍາກອນ",
    "previewResource": "ການສະແດງຊັບພະຍາກອນ",
    "helpPoint": "ຄູ່ມືການຊ່ວຍເຫຼືອ",
    "isEvaluation": "ທ່ານໄດ້ປະເມີນຜົນແລ້ວ!",
    "selectEvaluation": "ທ່ານຍັງບໍ່ໄດ້ເລືອກການໃຫ້ຄະແນນ!",
    "evaluationSuccess": "ການປະເມີນຜົນ ສຳ ເລັດ",
    "topRelise": "ທາງເທີງ",
    "className": "ຊື່ຊັ້ນ",
    "resourceEvaluation": "ການໃຫ້ຄະແນນຊັບພະຍາກອນ"
  },
  "usercenter": {
    "386": "ເອກະສານການຮຽນຮູ້",
    "myCourse": "ຫລັກສູດຂອງຂ້ອຍ",
    "hours": "ເວລາ",
    "loginAccount": "ເຂົ້າສູ່ລະບົບບັນຊີ",
    "htllo": "ສະບາຍດີ",
    "welcomeMessage": "ຂໍອວຍພອນໃຫ້ທ່ານມີຄວາມສຸກທຸກໆວັນ",
    "underway": "ເຈົ້າ ກຳ ລັງເຮັດຢູ່",
    "annualAssessment": "ການປະເມີນປະ ຈຳ ປີ",
    "searchTips": "ໃສ່ຊື່ຫຼັກສູດທີ່ຄົ້ນຫາ",
    "completed": "ສຳ ເລັດຮູບ",
    "allCourses": "ທຸກວິຊາ",
    "requiredCourses": "ຫລັກສູດທີ່ຕ້ອງການ",
    "electiveCourses": "ຫຼັກສູດການເລືອກຕັ້ງ",
    "all": "ທັງ ໝົດ",
    "ongoing": "ການປຸງແຕ່ງ",
    "learnTo": "ຮຽນຮູ້ທີ່ຈະ",
    "inExams": "ເຮັດການທົດສອບ",
    "noExams": "ບໍ່ມີການສອບເສັງ",
    "delete": "ລົບ",
    "pleaseSelect": "ກະລຸນາເລືອກ",
    "searchOnlineTips": "ຄົ້ນຫາຫ້ອງຮຽນພິເສດ online ທີ່ທ່ານສົນໃຈ",
    "passedCourse": "ຜ່ານໄປ",
    "failedCourse": "ບໍ່ໄດ້ຜ່ານ",
    "myOnlineCourse": "ຫ້ອງຮຽນພິເສດ online ຂອງຂ້ອຍ",
    "myFaceCourse": "ຫ້ອງຮຽນຝຶກອົບຮົມແບບ ໜ້າ ຕໍ່ ໜ້າ ຂອງຂ້ອຍ",
    "searchFaceTips": "ຄົ້ນຫາຫລັກສູດທີ່ທ່ານສົນໃຈ",
    "myExams": "ການສອບເສັງຂອງຂ້ອຍ",
    "allExams": "ການສອບເສັງທັງ ໝົດ",
    "makeUpExam": "ທີ່ຈະແຕ່ງຂຶ້ນ",
    "marking": "ເຄື່ອງ ໝາຍ",
    "onExam": "ການສອບເສັງໃນຄວາມຄືບ ໜ້າ",
    "passedExam": "ການສອບເສັງຜ່ານ",
    "examHours": "ໄລຍະເວລາຂອງການທົດສອບ",
    "examOver": "ການສອບເສັງຈົບລົງແລ້ວ",
    "exam": "ການກວດກາ",
    "examLog": "ບັນທຶກການສອບເສັງ",
    "myScore": "ຄະແນນຂອງຂ້ອຍ",
    "surplusMakeUpExam": "ການສອບເສັງເຮັດແຕ່ງ ໜ້າ ທີ່ຍັງເຫຼືອ",
    "times": "ເທື່ອ",
    "searchExamTips": "ໃສ່ຊື່ຂອງການຄົ້ນຫາ",
    "haveTime": "ເວ​ລາ​ທີ່​ເຫຼືອ",
    "question": "ຄຳ ຖາມ",
    "eachQuestion": "ແຕ່ລະ ຄຳ ຖາມ",
    "score": "ນາທີ",
    "examExplain": "ລາຍລະອຽດຂອງການສອບເສັງ",
    "confirmHandExams": "ບໍ່ວ່າຈະເປັນການຢືນຢັນການຍື່ນສະ ເໜີ",
    "autoSaveFailed": "ການປະຢັດອັດຕະໂນມັດລົ້ມເຫລວ",
    "autoSaveSuccess": "ປະຢັດອັດຕະໂນມັດ",
    "handExamsSuccess": "ໄດ້ປະສົບຜົນ ສຳ ເລັດແລ້ວ",
    "yourScore": "ຄະ​ແນນ​ຂອງ​ເຈົ້າ",
    "noPublicAnswers": "ຄຳ ຕອບຈະບໍ່ຖືກປະກາດ ສຳ ລັບການສອບເສັງນີ້",
    "noPublicResult": "ເອກະສານທົດສອບຈະບໍ່ຖືກປະກາດ",
    "reExam": "ທົດລອງ ໃໝ່",
    "practice": "ອອກ ກຳ ລັງກາຍ",
    "hasCollected": "ເກັບກໍາຂໍ້ມູນ",
    "emptyAnswer": "ຕົວເລືອກຫລື ຄຳ ຕອບຂອງເນື້ອຫາບໍ່ສາມາດຫວ່າງໄດ້",
    "isCorrect": "ການແກ້ໄຂໃນທາງບວກ",
    "myCollected": "ການລວບລວມຂອງຂ້ອຍ",
    "courseCollected": "ການເກັບຫຼັກສູດ",
    "examCollected": "ຄຳ ຖາມທົດສອບ",
    "deleteCollected": "ດຶງອອກຈາກສິ່ງທີ່ມັກ",
    "myLeave": "ການລາພັກຂອງຂ້ອຍ",
    "allLeave": "ໃບປະກາດທັງ ໝົດ",
    "needAudit": "ທີ່ຍັງຄ້າງ",
    "auditDate": "ເວລາສະ ໝັກ",
    "searchLeaveTips": "ຊອກຫາໃບປະກາດທີ່ທ່ານສົນໃຈ",
    "checkInfo": "ເບິ່ງລາຍລະອຽດ",
    "cancelLeave": "ຍົກເລີກການລາອອກ",
    "leaveInfo": "ອອກລາຍລະອຽດ",
    "leaveState": "ລັດໃນປະຈຸບັນ",
    "teamLeader": "ຜູ້ ນຳ ກຸ່ມ",
    "committeeMembers": "ຄະນະ ກຳ ມະການກວດກາວິໄນຂອງອົງກອນ",
    "headmaster": "ອາຈານສອນ",
    "schoolLeader": "ຜູ້ ນຳ ໂຮງຮຽນ",
    "student": "ຜູ້ຝຶກອົບຮົມ",
    "auditMessage": "ເຫດຜົນ ສຳ ລັບການອະນຸມັດ",
    "onBusiness": "ສຳ ລັບທຸລະກິດ",
    "personal": "ດ້ວຍເຫດຜົນສ່ວນຕົວ",
    "rejectReasons": "ເຫດຜົນ ສຳ ລັບການປະຕິເສດ",
    "confirmCancel": "ຢືນຢັນວ່າຈະຍົກເລີກການລາພັກ",
    "cancelButton": "ຖອນຄືນ",
    "cancelTitle": "ການຢັ້ງຢືນການຖອນຄືນ",
    "empty": "ບໍ່",
    "wrongQuestionBank": "ທະນາຄານ ຄຳ ຖາມທີ່ບໍ່ຖືກຕ້ອງຂອງຂ້ອຍ",
    "searchWrongTips": "ຄົ້ນຫາ ຄຳ ຖາມທີ່ບໍ່ຖືກຕ້ອງທີ່ທ່ານສົນໃຈ",
    "deleteWrongQuestion": "ເອົາທະນາຄານ ຄຳ ຖາມທີ່ບໍ່ຖືກຕ້ອງອອກ",
    "myQuestionnaire": "ແບບສອບຖາມຂອງຂ້ອຍ",
    "isCompleted": "ສຳ ເລັດ",
    "isOver": "ໃນໄລຍະ",
    "searchQuestionnaireTips": "ໃສ່ຊື່ ຄຳ ຖາມຄົ້ນຫາ",
    "questionnaireDate": "ແບບສອບຖາມເວລາ",
    "startQuestionnaire": "ເລີ່ມຕົ້ນຕອບ",
    "checkQuestionnaire": "ເບິ່ງແບບສອບຖາມ",
    "allTeacher": "ອາຈານທຸກຄົນ",
    "newTeacher": "ເພີ່ມຄູ",
    "searchTeacherTips": "ຄົ້ນຫາອາຈານທີ່ທ່ານສົນໃຈ",
    "checkTeacher": "ເບິ່ງ",
    "editTeacher": "ດັດແກ້",
    "workingIn": "ເຮັດວຽກຢູ່",
    "location": "ສະຖານທີ່ຖາວອນ",
    "confirmDelete": "ລົບລ້າງການຢືນຢັນ",
    "confirmDeleteTips": "ຢືນຢັນການລົບ",
    "recommendTeacher": "ຄຳ ແນະ ນຳ ຂອງອາຈານ",
    "addTeachers": "ອາຈານ ໃໝ່",
    "teacherInfo": "ຂໍ້​ມູນ​ສ່ວນ​ຕົວ",
    "teacherName": "ຊື່ອາຈານ",
    "workUnit": "ນາຍຈ້າງ",
    "contact": "ລາຍລະອຽດຕິດຕໍ່",
    "teacherNameTips": "ກະລຸນາໃສ່ຊື່ຂອງອາຈານ",
    "teacherWorkUnitTips": "ກະລຸນາໃສ່ນາຍຈ້າງ",
    "teacherContactTips": "ກະລຸນາໃສ່ຂໍ້ມູນຕິດຕໍ່ຂອງອາຈານ",
    "teacherLocationTips": "ກະລຸນາໃສ່ທີ່ຢູ່ຖາວອນ",
    "teacherDescTips": "ກະລຸນາໃສ່ຂໍ້ມູນຂອງຄູ",
    "teachingInfo": "ຂໍ້ມູນການສິດສອນ",
    "teachingExpertise": "ການສອນຄວາມ ຊຳ ນານ",
    "fitLevel": "ເໝາະ ແກ່ການສອນໃນລະດັບວັດຖຸ",
    "fitBusiness": "ເໝາະ ສຳ ລັບສາຍທຸລະກິດ",
    "ruleNumber": "ກະລຸນາໃສ່ເລກເຕັມພາຍໃນ 8 ຕົວເລກ (ລວມທັງ 8 ຕົວເລກ)",
    "rulePhone": "ກະລຸນາໃສ່ເບີໂທລະສັບທີ່ຖືກຕ້ອງ",
    "ruleString": "ກະລຸນາຂຽນ 80 ໂຕອັກສອນ (ລວມທັງ 80 ຕົວອັກສອນ)",
    "ruleIsNumber": "ກະລຸນາໃສ່ເບີ",
    "pause": "ການເກັບຮັກສາຊົ່ວຄາວ",
    "teachingStyle": "ຮູບແບບການບັນຍາຍ",
    "teachingExpertiseTips": "ກະລຸນາໃສ່ຄວາມ ຊຳ ນານການສອນຂອງຄູ",
    "fitLevelTips": "ກະລຸນາເລືອກລະດັບທີ່ ເໝາະ ສົມກັບກຸ່ມເປົ້າ ໝາຍ",
    "fitBusinessTips": "ກະລຸນາເລືອກສາຍທຸລະກິດທີ່ ເໝາະ ສົມ",
    "chargeInfoTips": "ກະລຸນາໃສ່ມາດຕະຖານສາກໄຟ",
    "teachingStyleTips": "ກະລຸນາໃສ່ແບບບັນຍາຍຂອງອາຈານ",
    "otherInfo": "ຂໍ້​ມູນ​ອື່ນ ໆ",
    "recommendUnit": "ແນະ ນຳ ໂດຍ",
    "otherOption": "ບັນຫາອື່ນໆ",
    "otherOptionTips": "ກະລຸນາໃສ່ສິ່ງອື່ນໆທີ່ຕ້ອງການເພີ່ມ",
    "isRequired": "ລາຍການນີ້ແມ່ນ ຈຳ ເປັນ",
    "pauseSuccess": "ບັນທຶກຢ່າງ ສຳ ເລັດຜົນ",
    "phoneWrong": "ກະລຸນາໃສ່ເບີໂທລະສັບທີ່ຖືກຕ້ອງ",
    "junior": "ນັກຮຽນມັດທະຍົມຕອນປາຍ",
    "highSchool": "ນັກຮຽນມັດທະຍົມຕອນປາຍ",
    "english": "ພາສາອັງກິດ",
    "mathematics": "ຄະນິດສາດ",
    "recommendSuccessTips": "ທ່ານໄດ້ສົ່ງຄູທີ່ແນະ ນຳ ໃຫ້ປະສົບຜົນ ສຳ ເລັດແລ້ວ, ພາຍຫຼັງການກວດຜ່ານ, ຄູຈະຖືກເພີ່ມເຂົ້າໃນສະລອຍນ້ ຳ ຂອງຄູ",
    "goBackrecommend": "ກັບໄປທີ່ຂໍ້ສະ ເໜີ ແນະຂອງຄູ",
    "checkTeacherInfo": "ເບິ່ງຄູອາຈານ",
    "currentState": "ລັດໃນປະຈຸບັນ",
    "chargeInfo": "ຄ່າບໍລິການ",
    "myCertificate": "ໃບຢັ້ງຢືນຂອງຂ້ອຍ",
    "learningArchives": "ເອກະສານການຮຽນຮູ້",
    "allCertificate": "ໃບຢັ້ງຢືນທັງ ໝົດ",
    "onlineCourse": "ຫ້ອງຮຽນ Online",
    "faceCourse": "ຊັ້ນ ໜ້າ ຕໍ່ ໜ້າ",
    "exams": "ການກວດກາ",
    "baseInfo": "ຂໍ້ມູນພື້ນຖານ",
    "userName": "ຊື່ຜູ້ໃຊ້",
    "name": "ຊື່",
    "company": "ໜ່ວຍ ປະຈຸບັນ",
    "learningExperience": "ສຶກສາປະຫວັດສາດ",
    "assessmentIndex": "ດັດຊະນີການປະເມີນຜົນ",
    "assessmentStatus": "ສະຖານະການປະເມີນຜົນ",
    "assessmentTime": "ເວລາທົດສອບ",
    "onlineLearning": "ການຮຽນຮູ້ທາງອິນເຕີເນັດ",
    "year": "ປີ",
    "faceOutProduceHours": "ການສິດສອນແບບຕໍ່ ໜ້າ (ຊົ່ວໂມງຮຽນ)",
    "notFaceOutProduceHours": "ການສອນແບບບໍ່ເຕັມເວລາ (ເວລາຮຽນ)",
    "onlineCenterLearnHours": "ການຮຽນຮູ້ແບບສຸມ online (ຊົ່ວໂມງຮຽນ)",
    "onlineSelfLearnHours": "ການຮຽນດ້ວຍຕົນເອງທາງອິນເຕີເນັດ (ຊົ່ວໂມງຮຽນ)",
    "outCompanyLearnHours": "ໄປຮຽນຕ່າງປະເທດ (ຊົ່ວໂມງຮຽນ)",
    "allHours": "ໄລຍະເວລາທັງ ໝົດ",
    "onlineSelfLearn": "ການຮຽນຮູ້ແບບອັດຕະໂນມັດທາງອິນເຕີເນັດ",
    "onlineCentralizedLearning": "ການຮຽນຮູ້ແບບສຸມ online",
    "outCompanyLearn": "ການສຶກສາ ໜ່ວຍ ງານຕ່າງປະເທດ",
    "faceTrain": "ການຝຶກອົບຮົມແບບ ໜ້າ",
    "myNotice": "ຂໍ້ຄວາມຂອງຂ້ອຍ",
    "noticeSearchTips": "ຄົ້ນຫາຂ່າວທີ່ທ່ານສົນໃຈ",
    "systemNotice": "ເຕືອນລະບົບ",
    "message": "ຈົດ ໝາຍ ສ່ວນຕົວ"
  },
  "questionnaire": {
    "notParticipat": "ບໍ່ມີສ່ວນຮ່ວມ",
    "description": "ລາຍລະອຽດຂອງແບບສອບຖາມ",
    "save": "ປະຢັດ",
    "export": "ການສົ່ງອອກ",
    "printing": "ພິມ",
    "handed": "ປະຕິບັດວຽກມອບ ໝາຍ",
    "topics": "ຫົວຂໍ້",
    "examList": "ລາຍຊື່ ຄຳ ຖາມທົດສອບ",
    "tableQuestions": "ຄຳ ຖາມກ່ຽວກັບຕາຕະລາງ",
    "newLine": "ເພີ່ມແຖວ",
    "deleteLine": "ລົບແຖວ",
    "sort": "ຈຳ ນວນ Serial",
    "content": "ເນື້ອຫາ",
    "shortQuestion": "ຄຳ ຕອບສັ້ນ",
    "inputContent": "ກະລຸນາໃສ່ເນື້ອໃນ ຄຳ ຕອບ",
    "multiple": "ຫລາຍທາງເລືອກ",
    "single": "ຫລາຍທາງເລືອກ",
    "saveSuccess": "ບັນທຶກຢ່າງ ສຳ ເລັດຜົນ",
    "submitSuccess": "ຍື່ນສະ ເໜີ ສຳ ເລັດແລ້ວ",
    "submitTips": "ທ່ານໄດ້ສົ່ງແບບສອບຖາມໃຫ້ປະສົບຜົນ ສຳ ເລັດ, ຂໍຂອບໃຈທ່ານທີ່ເຂົ້າຮ່ວມ",
    "closePage": "ປິດ ໜ້າ ນີ້"
  },
  "play": {
    "endStudy": "ຈົບການສຶກສາ",
    "tips": "ຄຳ ແນະ ນຳ",
    "playTips": "ຄຳ ເຕືອນ: ເພື່ອໃຫ້ແນ່ໃຈວ່າເວລາການສຶກສາຂອງທ່ານຖືກບັນທຶກເປັນປົກກະຕິໂດຍລະບົບ, ກະລຸນາກົດປຸ່ມ \"ຈົບການສຶກສາ\" ຢູ່ແຈຂວາເທິງເພື່ອອອກຈາກການສຶກສາຖ້າທ່ານປິດ browser ໂດຍກົງ, ເວລາການສຶກສາຂອງທ່ານອາດຈະບໍ່ຖືກບັນທຶກເປັນປົກກະຕິ.",
    "notShowAgain": "ຢ່າກະຕຸ້ນຂ່າວສານນີ້ອີກ",
    "gotIt": "ຂ້ອຍ​ເຂົ້າ​ໃຈ​ແລ້ວ",
    "chapter": "ບົດ",
    "chapterText1": "ກ່ອນອື່ນ ໝົດ",
    "chapterText2": "ບົດ",
    "note": "ບັນທຶກ",
    "noteBlockTitle": "ບັນທຶກ",
    "evaluate": "ການປະເມີນຜົນ",
    "evaluateStar": "ດາວ",
    "saveEvaluate": "ຍື່ນສະເຫນີ",
    "notePlaceholder": "ກະລຸນາໃສ່ບັນທຶກ",
    "closeTips": "ລະບົບອາດຈະບໍ່ປະຫຍັດການປ່ຽນແປງຂອງທ່ານ",
    "closeButton": "ໄປ​ໄກໆ",
    "autoStop": "ຢຸດຫຼີ້ນໂດຍອັດຕະໂນມັດ",
    "autoStopTips": "ເນື່ອງຈາກວ່າທ່ານບໍ່ໄດ້ປະຕິບັດງານເປັນເວລາດົນນານ, ລະບົບໄດ້ຢຸດການຫຼີ້ນວີດີໂອໂດຍອັດຕະໂນມັດ",
    "confirmOut": "ທ່ານແນ່ໃຈບໍ່ອອກຈາກການຫຼີ້ນ?",
    "closeOrNot": "ບໍ່ວ່າຈະປິດ ໜ້າ ຈໍປັດຈຸບັນ",
    "noCoursePlay": "ບໍ່ມີເຄື່ອງຫຼີ້ນທີ່ສາມາດຫຼີ້ນໄດ້ໃນຫຼັກສູດປະຈຸບັນ",
    "attention": "ກະ​ລຸ​ນາ​ບັນ​ທຶກ!"
  }
};